// extracted by mini-css-extract-plugin
export default {"button-change":"SignInForm_button-change__6+wgf","forgot_password":"SignInForm_forgot_password__tuL6X"};